export enum LineItemType {
    MAINITEM = 'mainitem',
    UPSELL = 'upsell',
    FREE = 'free',
    ACCESSORY=  'accessory',
    SUBITEM = 'subitem',
    ADDITIONALCHARGE = 'additionalcharge'
}